import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { device } from 'helpers/device';
import Title from 'components/Title';
import Line from 'components/Line';
import ContactSection from 'components/ContactSection';

/* Single white column; no horizontal padding — ContactSection totals 1120px with its own laptop gutters (content-box). */
const Content = styled.div`
	max-width: 1120px;
	margin: 0 auto;
	padding: 120px 0 0;
	background-color: ${(p) => p.theme.colors.white.primary};
	box-sizing: border-box;
`;

const TextSection = styled.section`
	padding: 0 16px 32px;

	@media ${device.laptop} {
		padding: 0 80px 48px;
	}
`;

const Intro = styled.p`
	font-size: 18px;
	line-height: 28px;
	letter-spacing: -0.5px;
	color: ${(p) => p.theme.colors.text.secondary};
	margin: 0 0 24px;
`;

const SectionLink = styled.a`
	font-size: 18px;
	font-weight: 600;
	color: ${(p) => p.theme.colors.ascent.primary};
	text-decoration: underline;
	text-underline-offset: 4px;

	&:hover {
		text-decoration: none;
	}
`;

const Beboere = () => {
	const { t } = useTranslation();

	return (
		<Content>
			<TextSection>
				<Line />
				<Title>{t('beboere.residentInquiriesTitle')}</Title>
				<Intro>{t('beboere.residentInquiriesIntro')}</Intro>
				<SectionLink href='http://kontakt.norsepm.dk/'>
					{t('beboere.residentInquiriesLink')}
				</SectionLink>
			</TextSection>
			<TextSection>
				<Line />
				<Title>{t('beboere.opsigelseTitle')}</Title>
				<Intro>{t('beboere.opsigelseIntro')}</Intro>
				<SectionLink href='https://norsepm.dk/opsigelse-af-lejemaal'>
					{t('beboere.opsigelseLink')}
				</SectionLink>
			</TextSection>
			<ContactSection />
		</Content>
	);
};

export default Beboere;
